import {
  PaymentMethodValues,
  paymentTypeMap,
} from '../../../pages/shopping-basket/cash-payment/utils/helpers';
import {CreditPaymentResponse} from '../../../pages/shopping-basket/cash-payment/utils/types';
import request from '../../axios';

export const getStoreOrderCreditTransactionPrice = async (
  storeGuid?: string,
  paymentType?: PaymentMethodValues,
) => {
  const {data}: {data: CreditPaymentResponse} = await request.get(
    `/api/v2/payment/calculate-store-order-price`,
    {
      params: {
        store_order: storeGuid,
        payment_type: paymentType ? paymentTypeMap[paymentType] : undefined,
      },
    },
  );

  return data;
};
